import { Link } from "react-router-dom";

export default function ServiceCard({ title, image, index }) {
  return (
    <Link to={"/our_services"}>
      <div
        className={`flex group ${
          index % 2 === 0 ? "flex-col" : "flex-col laptopS:flex-col-reverse"
        }   items-center gap-5`}
      >
        <h3 className='select-none flex justify-center text-center bg-primary px-4 py-2 rounded-custom-14 text-white text-custom-24 w-[18rem] h-14'>
          {title}
        </h3>
        <div className='relative'>
          <img
            src={image}
            alt='Placeholder'
            className='rounded-custom-24 z-10 w-[18rem] h-[18rem] object-cover'
          />
          <div
            className={`absolute rotate-[2deg] group-hover:rotate-[5deg] transition-all ${
              index % 2 === 0
                ? "top-[1rem] right-[1rem]"
                : "top-[1rem] right-[1rem] laptopS:right-0 laptopS:top-[-1rem] laptopS:left-[1rem]"
            } -z-10 bg-primary w-[18rem] h-[18rem] rounded-custom-24`}
          />
        </div>
      </div>
    </Link>
  );
}
